import { Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';

import { subscriptionCustomerListTableHead } from './constants';

export const SubscriptionCustomerListHeader = () => {
  return (
    <Stack>
      <TableHeadContainer px={Spacing['inline.xxxs']}>
        {subscriptionCustomerListTableHead.map((item, index) => (
          <TableHeadItem key={`${item.title}-${index}`} {...item} />
        ))}
      </TableHeadContainer>
    </Stack>
  );
};
